export default __webpack_public_path__ + "static/media/015-jeep.4aa93510.svg";